<div class="modal-overlay">

    <div class="modal-container">

        <div class="modal-header">
            <h2>Generate Key Pair</h2>
            <button class="close-btn" (click)="finish()">✕</button>
        </div>

        <div class="modal-body">

            <div
                class="success-box flex items-center justify-center gap-2 border border-green-400 bg-green-50 text-green-700 p-3 text-center">
                <i class="ri-checkbox-circle-line text-xl"></i>
                <span>Key pair successfully generated.</span>
            </div>

            <p class="desc">
                To help protect your security, store your secret access key securely
                and do not share it.
            </p>

            <button class="download-btn" (click)="downloadKey()">
                Download Key File
            </button>

        </div>

        <div class="warning-box flex items-center gap-2 bg-blue-100 p-3 text-blue-700">
            <i class="ri-information-line text-xl"></i>
            Please save the private key, you will not be able to obtain it later.
        </div>

        <div class="modal-footer">
            <button class="finish-btn" (click)="finish()">Finish</button>
        </div>

    </div>

</div>